// site1/frontend/src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from "react-router-dom";
import api from './api';
import { Analytics } from '@vercel/analytics/react';

import SignupPage from "./components/SignUp"
import LoginPage from "./components/LogInPage";


import HomePage from "./pages/homepagex";





import BlogPage from "./pages/BlogPage";
import TermsPage from "./pages/terms";
import PrivacyPage from "./pages/privacy";
import ForgotPassword from "./pages/ForgotPassword";

import BlogPost1 from "./pages/Blogs/blog1";
import BlogPost2 from "./pages/Blogs/blog2";


import CampfirePage from "./pages/campfirepagex";
import HistoryPage2 from './pages/History/HistoryStages/HistoryPage2';  

import HistoryPageAC2 from './pages/History/HistoryStages/AncientCivilisations'; 
import HistoryPageCA from './pages/History/HistoryStages/ClassicalAntiquity';
import HistoryPageMA from './pages/History/HistoryStages/MiddleAges'; 
import HistoryPageR from './pages/History/HistoryStages/Renaissance';   
import HistoryPageEM from './pages/History/HistoryStages/EarlyModern';  
import HistoryPageAOR from './pages/History/HistoryStages/AgeOfRevolutions';  
import HistoryPage19th from './pages/History/HistoryStages/19thcentury';  
import HistoryPage20th from './pages/History/HistoryStages/20thcentury';  
import HistoryPageContemporary from './pages/History/HistoryStages/Contemporary';  
import HistoryPageHOST from './pages/History/HistoryStages/HOST';  




import HistoryPageEgypt from './pages/History/AncientHistory/HistoryPageEgypt';  
import HistoryPageEgyptGo from './pages/History/AncientHistory/HistoryPageEgyptGo'; 
import HistoryPageChina from './pages/History/AncientHistory/HistoryPageChina'; 
import HistoryPageChinaGo from './pages/History/AncientHistory/HistoryPageChinaGo'; 
import HistoryPageMesopotamia from './pages/History/AncientHistory/HistoryPageMesopotamia'; 
import HistoryPageMesopotamiaGo from './pages/History/AncientHistory/HistoryPageMesopotamiaGo'; 
import HistoryPageMesoamerica from "./pages/History/AncientHistory/HistoryPageMesoamerica";
import HistoryPageMesoamericaGo from "./pages/History/AncientHistory/HistoryPageMesoamericaGo";
import HistoryPageIndusvalley from "./pages/History/AncientHistory/HistoryPageIndusvalley";
import HistoryPageIndusvalleyGo from "./pages/History/AncientHistory/HistoryPageIndusvalleyGo";


import HistoryPageGreece from "./pages/History/ClassicalAntiquity/HistoryPageGreece";
import HistoryPageRome from "./pages/History/ClassicalAntiquity/HistoryPageRome";
import HistoryPagePersia from "./pages/History/ClassicalAntiquity/HistoryPagePersia";
import HistoryPageHellenistic from "./pages/History/ClassicalAntiquity/HistoryPageHellenistic";
import HistoryPageIndia from "./pages/History/ClassicalAntiquity/HistoryPageIndia";
import HistoryPageHan from "./pages/History/ClassicalAntiquity/HistoryPageHan";

import HistoryPageGreeceGo from "./pages/History/ClassicalAntiquity/HistoryPageGreeceGo";
import HistoryPageRomeGo from "./pages/History/ClassicalAntiquity/HistoryPageRomeGo";
import HistoryPagePersiaGo from "./pages/History/ClassicalAntiquity/HistoryPagePersiaGo";
import HistoryPageHellenisticGo from "./pages/History/ClassicalAntiquity/HistoryPageHellenisticGo";
import HistoryPageIndiaGo from "./pages/History/ClassicalAntiquity/HistoryPageIndiaGo";
import HistoryPageHanGo from "./pages/History/ClassicalAntiquity/HistoryPageHanGo";



import HistoryPageByzantine from "./pages/History/MiddleAges/ByzantineEmpire";
import HistoryPageByzantineGo from "./pages/History/MiddleAges/ByzantineEmpireGo";
import HistoryPageCaliphates from "./pages/History/MiddleAges/IslamicCaliphates";
import HistoryPageCaliphatesGo from "./pages/History/MiddleAges/IslamicCaliphatesGo";
import HistoryPageMedieval from "./pages/History/MiddleAges/MedievalEurope";
import HistoryPageMedievalGo from "./pages/History/MiddleAges/MedievalEuropeGo";
import HistoryPageMongols from "./pages/History/MiddleAges/MongolEmpire";
import HistoryPageMongolsGo from "./pages/History/MiddleAges/MongolEmpireGo";
import HistoryPageCrusades from "./pages/History/MiddleAges/Crusades";
import HistoryPageCrusadesGo from "./pages/History/MiddleAges/CrusadesGo";
import HistoryPageJapan from "./pages/History/MiddleAges/FeudalJapan";
import HistoryPageJapanGo from "./pages/History/MiddleAges/FeudalJapanGo";
import HistoryPageAfrica from "./pages/History/MiddleAges/AfricanKingdoms";
import HistoryPageAfricaGo from "./pages/History/MiddleAges/AfricanKingdomsGo";

import HistoryPageItalianRenaissance from "./pages/History/Renaissance/ItalianRenaissance";
import HistoryPageItalianRenaissanceGo from "./pages/History/Renaissance/ItalianRenaissanceGo";
import HistoryPageNorthernRenaissance from "./pages/History/Renaissance/NorthernRenaissance";
import HistoryPageNorthernRenaissanceGo from "./pages/History/Renaissance/NorthernRenaissanceGo";
import HistoryPageProtestantReformation from "./pages/History/Renaissance/ProtestantReformation";
import HistoryPageProtestantReformationGo from "./pages/History/Renaissance/ProtestantReformationGo";
import HistoryPageCatholicCounterReformation from "./pages/History/Renaissance/CatholicCounterReformation";
import HistoryPageCatholicCounterReformationGo from "./pages/History/Renaissance/CatholicCounterReformationGo";
import HistoryPageScientificRevolution from "./pages/History/Renaissance/ScientificRevolution";
import HistoryPageScientificRevolutionGo from "./pages/History/Renaissance/ScientificRevolutionGo";

import HistoryPageEuropeanMaritimeEmpires from "./pages/History/EarlyModern/EuropeanMaritimeEmpires";
import HistoryPageEuropeanMaritimeEmpiresGo from "./pages/History/EarlyModern/EuropeanMaritimeEmpiresGo";
import HistoryPageColumbianExchange from "./pages/History/EarlyModern/ColumbianExchange";
import HistoryPageColumbianExchangeGo from "./pages/History/EarlyModern/ColumbianExchangeGo";
import HistoryPageSpanishPortugueseColonization from "./pages/History/EarlyModern/SpanishPortugueseColonization";
import HistoryPageSpanishPortugueseColonizationGo from "./pages/History/EarlyModern/SpanishPortugueseColonizationGo";
import HistoryPageOttomanEmpire from "./pages/History/EarlyModern/OttomanEmpire";
import HistoryPageOttomanEmpireGo from "./pages/History/EarlyModern/OttomanEmpireGo";
import HistoryPageMingQingDynasties from "./pages/History/EarlyModern/MingQingDynasties";
import HistoryPageMingQingDynastiesGo from "./pages/History/EarlyModern/MingQingDynastiesGo";
import HistoryPageAztecIncaEmpires from "./pages/History/EarlyModern/AztecIncaEmpires";
import HistoryPageAztecIncaEmpiresGo from "./pages/History/EarlyModern/AztecIncaEmpiresGo";

import HistoryPageAgeOfEnlightenment from "./pages/History/AgeOfRevolutions/AgeOfEnlightenment";
import HistoryPageAgeOfEnlightenmentGo from "./pages/History/AgeOfRevolutions/AgeOfEnlightenmentGo";
import HistoryPageAmericanRevolution from "./pages/History/AgeOfRevolutions/AmericanRevolution";
import HistoryPageAmericanRevolutionGo from "./pages/History/AgeOfRevolutions/AmericanRevolutionGo";
import HistoryPageFrenchRevolution from "./pages/History/AgeOfRevolutions/FrenchRevolution";
import HistoryPageFrenchRevolutionGo from "./pages/History/AgeOfRevolutions/FrenchRevolutionGo";
import HistoryPageHaitianRevolution from "./pages/History/AgeOfRevolutions/HaitianRevolution";
import HistoryPageHaitianRevolutionGo from "./pages/History/AgeOfRevolutions/HaitianRevolutionGo";
import HistoryPageLatinAmericanWars from "./pages/History/AgeOfRevolutions/LatinAmericanWars";
import HistoryPageLatinAmericanWarsGo from "./pages/History/AgeOfRevolutions/LatinAmericanWarsGo";


import HistoryPageIndustrialRevolution from "./pages/History/19thcentury/IndustrialRevolution";
import HistoryPageIndustrialRevolutionGo from "./pages/History/19thcentury/IndustrialRevolutionGo";
import HistoryPageBritishEmpire from "./pages/History/19thcentury/BritishEmpire";
import HistoryPageBritishEmpireGo from "./pages/History/19thcentury/BritishEmpireGo";
import HistoryPageMeijiRestoration from "./pages/History/19thcentury/MeijiRestoration";
import HistoryPageMeijiRestorationGo from "./pages/History/19thcentury/MeijiRestorationGo";
import HistoryPageScrambleForAfrica from "./pages/History/19thcentury/ScrambleForAfrica";
import HistoryPageScrambleForAfricaGo from "./pages/History/19thcentury/ScrambleForAfricaGo";
import HistoryPageUnificationGermanyItaly from "./pages/History/19thcentury/UnificationGermanyItaly";
import HistoryPageUnificationGermanyItalyGo from "./pages/History/19thcentury/UnificationGermanyItalyGo";

import HistoryPageWorldWarI from "./pages/History/20thcentury/WorldWarI";
import HistoryPageWorldWarIGo from "./pages/History/20thcentury/WorldWarIGo";
import HistoryPageWorldWarII from "./pages/History/20thcentury/WorldWarII";
import HistoryPageWorldWarIIGo from "./pages/History/20thcentury/WorldWarIIGo";
import HistoryPageColdWar from "./pages/History/20thcentury/ColdWar";
import HistoryPageColdWarGo from "./pages/History/20thcentury/ColdWarGo";
import HistoryPageRussianRevolution from "./pages/History/20thcentury/RussianRevolution";
import HistoryPageRussianRevolutionGo from "./pages/History/20thcentury/RussianRevolutionGo";
import HistoryPageIndianIndependence from "./pages/History/20thcentury/IndianIndependence";
import HistoryPageIndianIndependenceGo from "./pages/History/20thcentury/IndianIndependenceGo";
import HistoryPageAfricanIndependence from "./pages/History/20thcentury/AfricanIndependence";
import HistoryPageAfricanIndependenceGo from "./pages/History/20thcentury/AfricanIndependenceGo";
import HistoryPageRiseFascismNazism from "./pages/History/20thcentury/RiseFascismNazism";
import HistoryPageRiseFascismNazismGo from "./pages/History/20thcentury/RiseFascismNazismGo";

import HistoryPageGlobalization from "./pages/History/Contemporary/Globalization";
import HistoryPageGlobalizationGo from "./pages/History/Contemporary/GlobalizationGo";
import HistoryPageDigitalRevolution from "./pages/History/Contemporary/DigitalRevolution";
import HistoryPageDigitalRevolutionGo from "./pages/History/Contemporary/DigitalRevolutionGo";
import HistoryPageClimateChange from "./pages/History/Contemporary/ClimateChange";
import HistoryPageClimateChangeGo from "./pages/History/Contemporary/ClimateChangeGo";
import HistoryPageRiseOfChina from "./pages/History/Contemporary/RiseOfChina";
import HistoryPageRiseOfChinaGo from "./pages/History/Contemporary/RiseOfChinaGo";
import HistoryPageModernConflicts from "./pages/History/Contemporary/ModernConflicts";
import HistoryPageModernConflictsGo from "./pages/History/Contemporary/ModernConflictsGo";
import HistoryPageSocialMovements from "./pages/History/Contemporary/SocialMovements";
import HistoryPageSocialMovementsGo from "./pages/History/Contemporary/SocialMovementsGo";

import HistoryPageIndustrialInnovations from "./pages/History/HOST/IndustrialInnovations";
import HistoryPageIndustrialInnovationsGo from "./pages/History/HOST/IndustrialInnovationsGo";
import HistoryPageSpaceRace from "./pages/History/HOST/SpaceRace";
import HistoryPageSpaceRaceGo from "./pages/History/HOST/SpaceRaceGo";
import HistoryPageComputersInternet from "./pages/History/HOST/ComputersInternet";
import HistoryPageComputersInternetGo from "./pages/History/HOST/ComputersInternetGo";
import HistoryPageMedicalBreakthroughs from "./pages/History/HOST/MedicalBreakthroughs";
import HistoryPageMedicalBreakthroughsGo from "./pages/History/HOST/MedicalBreakthroughsGo";
import HistoryPageAIAndRobotics from "./pages/History/HOST/AIAndRobotics";
import HistoryPageAIAndRoboticsGo from "./pages/History/HOST/AIAndRoboticsGo";



import RequireAuth from './components/RequireAuth';
//<Route path="/campfirepage" element={<CampfirePage />} />
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signin" element={<LoginPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/1" element={<BlogPost1 />} />
        <Route path="/blog/2" element={<BlogPost2 />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} ></Route>
        
        <Route element={<RequireAuth><Outlet/></RequireAuth>}>
        <Route path="/campfirepage" element={ <CampfirePage />} />
        <Route path="/history2" element={<HistoryPage2 />} />
        



        <Route path="/history-Ancient-Civilizations" element={<HistoryPageAC2 />} />
        <Route path="/History-Ancient-Egypt" element={<HistoryPageEgypt />} />
        <Route path="/History-Ancient-Egypt-Go" element={<HistoryPageEgyptGo />} />
        <Route path="/History-Ancient-China" element={<HistoryPageChina />} />
        <Route path="/History-Ancient-China-Go" element={<HistoryPageChinaGo />} />
        <Route path="/History-Ancient-Mesopotamia" element={<HistoryPageMesopotamia />} />
        <Route path="/History-Ancient-Mesopotamia-Go" element={<HistoryPageMesopotamiaGo />} />
        <Route path="/History-Ancient-Mesoamerica" element={<HistoryPageMesoamerica />} />
        <Route path="/History-Ancient-Mesoamerica-Go" element={<HistoryPageMesoamericaGo />} />
        <Route path="/History-Ancient-Indusvalley" element={<HistoryPageIndusvalley />} />
        <Route path="/History-Ancient-Indusvalley-Go" element={<HistoryPageIndusvalleyGo />} />

        <Route path="/history-classical-antiquity" element={<HistoryPageCA />} />
        <Route path="/History-Ancient-Greece" element={<HistoryPageGreece />} />
        <Route path="/History-Ancient-Rome" element={<HistoryPageRome />} />
        <Route path="/History-Persian-Empire" element={<HistoryPagePersia />} />
        <Route path="/History-Hellenistic-World" element={<HistoryPageHellenistic />} />
        <Route path="/History-Maurya-Gupta" element={<HistoryPageIndia />} />
        <Route path="/History-Han-Dynasty" element={<HistoryPageHan />} />

        <Route path="/History-Ancient-Greece-Go" element={<HistoryPageGreeceGo />} />
        <Route path="/History-Ancient-Rome-Go" element={<HistoryPageRomeGo />} />
        <Route path="/History-Persian-Empire-Go" element={<HistoryPagePersiaGo />} />
        <Route path="/History-Hellenistic-World-Go" element={<HistoryPageHellenisticGo />} />
        <Route path="/History-Maurya-Gupta-Go" element={<HistoryPageIndiaGo />} />
        <Route path="/History-Han-Dynasty-Go" element={<HistoryPageHanGo />} />




        <Route path="/history-middle-ages" element={<HistoryPageMA />} />
        <Route path="/History-Byzantine-Empire" element={<HistoryPageByzantine />} />
        <Route path="/History-Byzantine-Go" element={<HistoryPageByzantineGo />} />

        <Route path="/History-Islamic-Caliphates" element={<HistoryPageCaliphates />} />
        <Route path="/History-Islamic-Caliphates-Go" element={<HistoryPageCaliphatesGo />} />

        <Route path="/History-Medieval-Europe" element={<HistoryPageMedieval />} />
        <Route path="/History-Medieval-Europe-Go" element={<HistoryPageMedievalGo />} />

        <Route path="/History-Mongol-Empire" element={<HistoryPageMongols />} />
        <Route path="/History-Mongol-Empire-Go" element={<HistoryPageMongolsGo />} />

        <Route path="/History-Crusades" element={<HistoryPageCrusades />} />
        <Route path="/History-Crusades-Go" element={<HistoryPageCrusadesGo />} />

        <Route path="/History-Feudal-Japan" element={<HistoryPageJapan />} />
        <Route path="/History-Feudal-Japan-Go" element={<HistoryPageJapanGo />} />

        <Route path="/History-African-Kingdoms" element={<HistoryPageAfrica />} />
        <Route path="/History-African-Kingdoms-Go" element={<HistoryPageAfricaGo />} />


        <Route path="/history-renaissance" element={<HistoryPageR />} />
        <Route path="/History-Italian-Renaissance" element={<HistoryPageItalianRenaissance />} />
        <Route path="/History-Italian-Renaissance-Go" element={<HistoryPageItalianRenaissanceGo />} />

        <Route path="/History-Northern-Renaissance" element={<HistoryPageNorthernRenaissance />} />
        <Route path="/History-Northern-Renaissance-Go" element={<HistoryPageNorthernRenaissanceGo />} />

        <Route path="/History-Protestant-Reformation" element={<HistoryPageProtestantReformation />} />
        <Route path="/History-Protestant-Reformation-Go" element={<HistoryPageProtestantReformationGo />} />

        <Route path="/History-Catholic-Counter-Reformation" element={<HistoryPageCatholicCounterReformation />} />
        <Route path="/History-Catholic-Counter-Reformation-Go" element={<HistoryPageCatholicCounterReformationGo />} />

        <Route path="/History-Scientific-Revolution" element={<HistoryPageScientificRevolution />} />
        <Route path="/History-Scientific-Revolution-Go" element={<HistoryPageScientificRevolutionGo />} />

        <Route path="/history-early-modern" element={<HistoryPageEM />} />
        <Route path="/History-European-Maritime-Empires" element={<HistoryPageEuropeanMaritimeEmpires />} />
        <Route path="/History-European-Maritime-Empires-Go" element={<HistoryPageEuropeanMaritimeEmpiresGo />} />

        <Route path="/History-Columbian-Exchange" element={<HistoryPageColumbianExchange />} />
        <Route path="/History-Columbian-Exchange-Go" element={<HistoryPageColumbianExchangeGo />} />

        <Route path="/History-Spanish-Portuguese-Colonization" element={<HistoryPageSpanishPortugueseColonization />} />
        <Route path="/History-Spanish-Portuguese-Colonization-Go" element={<HistoryPageSpanishPortugueseColonizationGo />} />

        <Route path="/History-Ottoman-Empire" element={<HistoryPageOttomanEmpire />} />
        <Route path="/History-Ottoman-Empire-Go" element={<HistoryPageOttomanEmpireGo />} />

        <Route path="/History-Ming-Qing-Dynasties" element={<HistoryPageMingQingDynasties />} />
        <Route path="/History-Ming-Qing-Dynasties-Go" element={<HistoryPageMingQingDynastiesGo />} />

        <Route path="/History-Aztec-Inca-Empires" element={<HistoryPageAztecIncaEmpires />} />
        <Route path="/History-Aztec-Inca-Empires-Go" element={<HistoryPageAztecIncaEmpiresGo />} />


        <Route path="/history-age-of-revolutions" element={<HistoryPageAOR />} />
        <Route path="/History-Age-of-Enlightenment" element={<HistoryPageAgeOfEnlightenment />} />
        <Route path="/History-Age-of-Enlightenment-Go" element={<HistoryPageAgeOfEnlightenmentGo />} />

        <Route path="/History-American-Revolution" element={<HistoryPageAmericanRevolution />} />
        <Route path="/History-American-Revolution-Go" element={<HistoryPageAmericanRevolutionGo />} />

        <Route path="/History-French-Revolution" element={<HistoryPageFrenchRevolution />} />
        <Route path="/History-French-Revolution-Go" element={<HistoryPageFrenchRevolutionGo />} />

        <Route path="/History-Haitian-Revolution" element={<HistoryPageHaitianRevolution />} />
        <Route path="/History-Haitian-Revolution-Go" element={<HistoryPageHaitianRevolutionGo />} />

        <Route path="/History-Latin-American-Wars" element={<HistoryPageLatinAmericanWars />} />
        <Route path="/History-Latin-American-Wars-Go" element={<HistoryPageLatinAmericanWarsGo />} />

        <Route path="/history-19th-century" element={<HistoryPage19th />} />
        <Route path="/History-Industrial-Revolution" element={<HistoryPageIndustrialRevolution />} />
        <Route path="/History-Industrial-Revolution-Go" element={<HistoryPageIndustrialRevolutionGo />} />
        <Route path="/History-British-Empire" element={<HistoryPageBritishEmpire />} />
        <Route path="/History-British-Empire-Go" element={<HistoryPageBritishEmpireGo />} />
        <Route path="/History-Meiji-Restoration" element={<HistoryPageMeijiRestoration />} />
        <Route path="/History-Meiji-Restoration-Go" element={<HistoryPageMeijiRestorationGo />} />
        <Route path="/History-Scramble-for-Africa" element={<HistoryPageScrambleForAfrica />} />
        <Route path="/History-Scramble-for-Africa-Go" element={<HistoryPageScrambleForAfricaGo />} />
        <Route path="/History-Unification-Germany-Italy" element={<HistoryPageUnificationGermanyItaly />} />
        <Route path="/History-Unification-Germany-Italy-Go" element={<HistoryPageUnificationGermanyItalyGo />} />


        <Route path="/history-20th-century" element={<HistoryPage20th />} />
        <Route path="/History-World-War-I" element={<HistoryPageWorldWarI />} />
        <Route path="/History-World-War-I-Go" element={<HistoryPageWorldWarIGo />} />
        <Route path="/History-World-War-II" element={<HistoryPageWorldWarII />} />
        <Route path="/History-World-War-II-Go" element={<HistoryPageWorldWarIIGo />} />
        <Route path="/History-Cold-War" element={<HistoryPageColdWar />} />
        <Route path="/History-Cold-War-Go" element={<HistoryPageColdWarGo />} />
        <Route path="/History-Russian-Revolution" element={<HistoryPageRussianRevolution />} />
        <Route path="/History-Russian-Revolution-Go" element={<HistoryPageRussianRevolutionGo />} />
        <Route path="/History-Indian-Independence" element={<HistoryPageIndianIndependence />} />
        <Route path="/History-Indian-Independence-Go" element={<HistoryPageIndianIndependenceGo />} />
        <Route path="/History-African-Independence" element={<HistoryPageAfricanIndependence />} />
        <Route path="/History-African-Independence-Go" element={<HistoryPageAfricanIndependenceGo />} />
        <Route path="/History-Rise-Fascism-Nazism" element={<HistoryPageRiseFascismNazism />} />
        <Route path="/History-Rise-Fascism-Nazism-Go" element={<HistoryPageRiseFascismNazismGo />} />

        <Route path="/history-contemporary" element={<HistoryPageContemporary />} />
        <Route path="/History-Globalization" element={<HistoryPageGlobalization />} />
        <Route path="/History-Globalization-Go" element={<HistoryPageGlobalizationGo />} />
        <Route path="/History-Digital-Revolution" element={<HistoryPageDigitalRevolution />} />
        <Route path="/History-Digital-Revolution-Go" element={<HistoryPageDigitalRevolutionGo />} />
        <Route path="/History-Climate-Change" element={<HistoryPageClimateChange />} />
        <Route path="/History-Climate-Change-Go" element={<HistoryPageClimateChangeGo />} />
        <Route path="/History-Rise-of-China" element={<HistoryPageRiseOfChina />} />
        <Route path="/History-Rise-of-China-Go" element={<HistoryPageRiseOfChinaGo />} />
        <Route path="/History-Modern-Conflicts" element={<HistoryPageModernConflicts />} />
        <Route path="/History-Modern-Conflicts-Go" element={<HistoryPageModernConflictsGo />} />
        <Route path="/History-Social-Movements" element={<HistoryPageSocialMovements />} />
        <Route path="/History-Social-Movements-Go" element={<HistoryPageSocialMovementsGo />} />
        
        <Route path="/history-host" element={<HistoryPageHOST />} />
                
        <Route path="/History-Industrial-Innovations" element={<HistoryPageIndustrialInnovations />} />
        <Route path="/History-Industrial-Innovations-Go" element={<HistoryPageIndustrialInnovationsGo />} />
        <Route path="/History-Space-Race" element={<HistoryPageSpaceRace />} />
        <Route path="/History-Space-Race-Go" element={<HistoryPageSpaceRaceGo />} />
        <Route path="/History-Computers-Internet" element={<HistoryPageComputersInternet />} />
        <Route path="/History-Computers-Internet-Go" element={<HistoryPageComputersInternetGo />} />
        <Route path="/History-Medical-Breakthroughs" element={<HistoryPageMedicalBreakthroughs />} />
        <Route path="/History-Medical-Breakthroughs-Go" element={<HistoryPageMedicalBreakthroughsGo />} />
        <Route path="/History-AI-Robotics" element={<HistoryPageAIAndRobotics />} />
        <Route path="/History-AI-Robotics-Go" element={<HistoryPageAIAndRoboticsGo />} />
        </Route>






      </Routes>
       <Analytics />
    </Router>
  );
}

export default App;


